module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.labelTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.labelMessage[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-rounded btn-default align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModal('add-device-form')
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButton01[_vm.actualLanguage]))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-rounded btn-default",
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getCode
    }
  }, [(_vm.gettingCode) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.labelButton02[_vm.actualLanguage]))])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-418f7b40","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/BindingCode.vue
// module id = 1527
// module chunks = 4